import ServerCookie from 'cookie';
import BrowserCookie from 'js-cookie';
/**
 * Isomorphic function that takes a cookie key and returns a string value or undefined.
 * If a server-side context is provided, the function will read cookies from the given context.
 * Context can be a NextJS context containing the request's parsed cookies, a basic context object
 * containing the request and its headers, or a string representing the cookie header.
 * @param {string}               name          cookie name
 * @param {Object | string }     serverContext server context
 * @returns {string | undefined}               cookie value
 */ export const getCookie = (name, serverContext)=>{
    if (serverContext) {
        // server-side cookie handling
        const cookies = typeof serverContext === 'string' // cookie header string
         ? ServerCookie.parse(serverContext) : serverContext.req.cookies // NextJS pre-parsed cookies
         ? serverContext.req.cookies : ServerCookie.parse(serverContext.req.headers.cookie ?? ''); // http request cookie header
        return cookies[name];
    } else {
        // client-side cookie handling
        return BrowserCookie.get(name);
    }
};
export default getCookie;
